import { Fragment, ReactElement, useMemo } from 'react';
import { CivilUnionNotificationsNonResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionNotificationsNonResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CivilUnionNotificationsNonResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CivilUnionNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CivilUnionNotificationsNonResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchCivilUnionNonResidentNotificationShared from '../../research-notifications/research-civil-union-non-resident';

interface ResearchCivilUnionNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
}

const ResearchCivilUnionNonResidentNotificationCivilStatusShared = ({
  scope,
}: ResearchCivilUnionNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const editSipoUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/persona-sipo`;
  }, [goBackUrl]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return CivilUnionNotificationsNonResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CivilUnionNotificationsNonResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CivilUnionNotificationsNonResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CivilUnionNotificationsNonResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CivilUnionNotificationsNonResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchCivilUnionNonResidentNotificationShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
        editSipoUrl={editSipoUrl}
      />
    </Fragment>
  );
};

ResearchCivilUnionNonResidentNotificationCivilStatusShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default ResearchCivilUnionNonResidentNotificationCivilStatusShared;
